import React from 'react'
import Button from 'react-bootstrap/Button'
import BillingForm from '../BillingForm'
import { useSignup } from './Signup.hooks'

const StepBilling = () => {
  const { setView, updateBilling, billing } = useSignup()
  const formId = 'billing'

  const formAction = (form) => {
    updateBilling(form)
    setView('attendees')
  }

  return (
    <>
      <BillingForm
        formId={formId}
        onSubmit={formAction}
        initialState={billing}
      />
      <div className="d-flex justify-content-center">
        <Button
          variant="primary"
          size="lg"
          type="submit"
          style={{
            minWidth: '200px'
          }}
          form={formId}
        >
          Weiter
        </Button>
      </div>
    </>
  )
}

export default StepBilling
